import { Login } from "../../../features";

const LoginPage = () => {
  return <Login />;
};
export default LoginPage;
